module.exports = __webpack_public_path__ + "static/media/material-ui-logo.f8b9613b.png";